import { createSlice } from "@reduxjs/toolkit";
import {
  getCategoriesBuilder,
  getProductBuilder,
  getProductsBuilder,
  getProductsSearchBuilder,
  getProductsByCategoryBuilder,
  createCategoryBuilder,
  deleteCategoryBuilder,
  createProductBuilder,
  deleteProductBuilder,
  editProductBuilder,
} from "./builder";

const initialState = {
  products: {
    data: [],

    total: 0,
    perPage: 15,
    page: 1,
    maxReached: false,
    loading: true,
    createLoading: false,
    deleteLoading: false,
    editLoading: false,
    error: null,

    productsByCategory: {},
  },

  searchProducts: {
    data: [],
    total: 0,
    perPage: 15,
    page: 1,
    loading: true,
    maxReached: false,
    error: null,
  },

  selectedProduct: {
    data: {},
    loading: true,
    error: null,
  },

  categories: {
    data: [],
    loading: false,
    createLoading: false,
    deleteLoading: false,
    error: null,
  },
};

export const productsSlice = createSlice({
  name: "productsInfo",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    getProductsBuilder(builder);
    getProductBuilder(builder);
    getCategoriesBuilder(builder);
    getProductsByCategoryBuilder(builder);
    getProductsSearchBuilder(builder);
    createCategoryBuilder(builder);
    deleteCategoryBuilder(builder);
    createProductBuilder(builder);
    deleteProductBuilder(builder);
    editProductBuilder(builder);

    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = productsSlice.actions;

export const selectCategories = (state) => state.productsInfo.categories;
export const selectProducts = (state) => state.productsInfo.products;
export const selectSearchProducts = (state) =>
  state.productsInfo.searchProducts;
export const selectProduct = (state) => state.productsInfo.selectedProduct;
export const selectProductData = (state) =>
  state.productsInfo.selectedProduct.data;

export default productsSlice.reducer;
